// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mvys","title":"styles_title__1Ej9C"};